export { default } from './StuiIcon'
